var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.033,
    height: 19.867,
    viewBox: "524.983 60.983 25.033 19.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.808 80.827a.804.804 0 0 1-.804-.804v-1.071a6.706 6.706 0 0 0-6.698-6.699 6.706 6.706 0 0 0-6.698 6.699v1.071a.804.804 0 0 1-1.608 0v-1.071a8.25 8.25 0 0 1 2.433-5.873 8.25 8.25 0 0 1 5.873-2.433c2.219 0 4.305.864 5.873 2.433a8.25 8.25 0 0 1 2.433 5.873v1.071c0 .444-.36.804-.804.804Z",
    fill: "#1785d6",
    fillRule: "evenodd",
    "data-name": "Path 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.196 74.933a.804.804 0 0 1-.804-.804v-.536a4.56 4.56 0 0 0-4.555-4.555 4.56 4.56 0 0 0-4.554 4.555.804.804 0 0 1-1.608 0 6.17 6.17 0 0 1 6.162-6.163A6.17 6.17 0 0 1 550 73.593v.536c0 .444-.36.804-.804.804Z",
    fill: "#1785d6",
    fillRule: "evenodd",
    "data-name": "Path 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.306 72.253a5.096 5.096 0 0 1-5.09-5.09 5.096 5.096 0 0 1 5.09-5.091 5.096 5.096 0 0 1 5.09 5.09 5.096 5.096 0 0 1-5.09 5.091Zm0-8.574a3.487 3.487 0 0 0-3.483 3.484 3.487 3.487 0 0 0 3.483 3.483 3.487 3.487 0 0 0 3.483-3.483 3.487 3.487 0 0 0-3.483-3.484Z",
    fill: "#1785d6",
    fillRule: "evenodd",
    "data-name": "Path 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.837 69.038a4.024 4.024 0 0 1-4.019-4.019 4.024 4.024 0 0 1 4.02-4.019 4.023 4.023 0 0 1 4.018 4.02 4.023 4.023 0 0 1-4.019 4.018Zm0-6.43a2.414 2.414 0 0 0-2.411 2.411 2.414 2.414 0 0 0 2.411 2.411 2.414 2.414 0 0 0 2.412-2.41 2.414 2.414 0 0 0-2.412-2.412Z",
    fill: "#1785d6",
    fillRule: "evenodd",
    "data-name": "Path 39"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupHeaderIcon);
export default __webpack_public_path__ + "static/media/group-header-icon.acebd3445a2dcd178d230e762750c88c.svg";
export { ForwardRef as ReactComponent };